// CR-03: the per-question countdowns are saved so a reload does not hand the student
// their time back. They used to be stored under "timer-<questionIndex>", which named
// nothing but a position - so a second exam inherited the first one's clocks, and two
// students sharing a browser inherited each other's.
//
// The key now names the attempt. Everything that reads or writes a clock goes through
// here, because the timer component and the submission that reports elapsed time have to
// agree on the key exactly - when they disagreed, elapsed time came out as the whole
// allowance for every question.
//
// Every access is guarded: localStorage throws in a private window and when the quota is
// full, and a clock that cannot be saved should still run.

export const TIMER_PREFIX = "timer-";

export const timerKey = (assessmentId, userId, questionIndex) =>
  `${TIMER_PREFIX}${assessmentId || "na"}-${userId || "anon"}-${questionIndex}`;

export const readTimer = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value === null ? null : Number(value);
  } catch (e) {
    return null;
  }
};

export const writeTimer = (key, value) => {
  try {
    localStorage.setItem(key, String(value));
  } catch (e) {
    /* the clock keeps running in memory */
  }
};

// Removes saved clocks. Given an assessmentId it drops that exam's clocks and leaves
// every other key alone; given nothing it drops all clocks but still nothing else. It
// replaces a localStorage.clear() that threw away everything the app had stored.
export const clearTimers = (assessmentId) => {
  try {
    const match = assessmentId
      ? `${TIMER_PREFIX}${assessmentId}-`
      : TIMER_PREFIX;
    Object.keys(localStorage)
      .filter((key) => key.startsWith(match))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    /* nothing readable to clean up */
  }
};

// Drops the clocks of every exam except the one given - used when an exam loads, so a
// browser that has sat twenty papers does not carry twenty papers' worth of countdowns.
export const clearTimersExcept = (assessmentId) => {
  try {
    const keep = `${TIMER_PREFIX}${assessmentId}-`;
    Object.keys(localStorage)
      .filter((key) => key.startsWith(TIMER_PREFIX) && !key.startsWith(keep))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    /* nothing readable to clean up */
  }
};
